import React, { use, useEffect, useState } from "react";
import "./OpeningPage.css";
import { useNavigate, useLocation } from "react-router-dom";
import moment from "moment";
import { getSasToken, getSurveyDetails } from "../../../services/survey/survey.service";
import Loader from "../../common/Loader/Loader";
import { toast } from "react-toastify";
import { useTranslation } from "react-i18next";
import renderWithLinks from "../../../utils/linkGenerator";
import ModalComponent from "../../../components/common/ModalComponent/ModalComponent";
import worldIcon from "../../../assets/world.png";

const OpeningPage = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const { surveyId, surveyTitle, startDate, endDate, surveyLayoutId, surveyImageUrl, languageMasterId, createdDate, code } = location.state || {};
  const [backgroundImage, setBackgroundImage] = useState("");
  const [imageToken, setImageToken] = useState("");
  const [loading, setLoading] = useState(false);
  const [privacyChecked, setPrivacyChecked] = useState(false);
  const [lastFetchedLanguage, setLastFetchedLanguage] = useState(null);
  const { t, i18n } = useTranslation();
  const sessionLanguageDetails = JSON.parse(sessionStorage.getItem("selectedLanguageDetails") || "{}");
  const [isWarningModalOpen, setIsWarningModalOpen] = useState(false);
  const [isStartNowBtnDisabled, setIsStartNowBtnDisabled] = useState(false);
  const isExternalUserSurvey = sessionStorage.getItem("isExternalUserSurvey");

  useEffect(() => {
    const layoutData = JSON.parse(sessionStorage.getItem("layoutData"));
    setBackgroundImage(layoutData?.filter(item => item.id === surveyLayoutId)[0]);
    fetchSasToken();
  }, [])

  useEffect(() => {
      let isExternalSurvey = sessionStorage.getItem("isExternalUserSurvey")
      if(isExternalSurvey === 'true') {
        let isWarningModalShown = sessionStorage.getItem('externalUserSurveyWarningShown');
        if(isWarningModalShown && isWarningModalShown === 'true') return;
        else setIsWarningModalOpen(true)
      }
  },[])

  useEffect(() => {
    // This change is to handle external user survey link access
    const currentLanguageId = sessionLanguageDetails?.id || 1;
    if(code !== null && lastFetchedLanguage !== currentLanguageId) {
      fetchUserSurveyDetails(currentLanguageId);
    }
  }, [i18n.language, code, lastFetchedLanguage])

  useEffect(() => {
    if (isExternalUserSurvey === 'true') {
        sessionStorage.setItem("isExternalUserQuestionsPageOpen", false);
        const event = new Event('sessionStorageUpdated');
        window.dispatchEvent(event);
    }
  }, [isExternalUserSurvey])

  useEffect(() => {
    if (isExternalUserSurvey === 'false') {
      sessionStorage.setItem("isUserSurveysQuePageOpen", 'true');
      const event = new Event('sessionStorageUpdated1');
      window.dispatchEvent(event);
    }
  },[]);

  const fetchUserSurveyDetails = (languageId) => {
      setIsStartNowBtnDisabled(false);
      setLastFetchedLanguage(languageId);
      const data = {
        surveyId: surveyId,
        code: code,
        languageId: languageId,
      }
      getSurveyDetails(data).then((response) => {
        if (response?.message) {
          if(response?.message?.includes("expired")) {
            toast.error("No survey available in this language.", { position: "top-center", theme: "dark" });
            setIsStartNowBtnDisabled(true);
            // toast.error(t("noSurveysAvailable"), { position: "top-center", theme: "dark" });
          } else {
            sessionStorage.setItem("isExternalUserSurvey", true)
            navigate("/user/survey/user-response-page");
          }
          return;
        } else {
          const redirectToSurvey = () => {
            sessionStorage.setItem("isExternalUserSurvey", true)
            navigate("/user/survey/opening-page", { state: response?.data[0] });
          };
          sessionStorage.setItem("isExternalUserSurvey", false)
          localStorage.setItem(
            "userSurveyInfo",
            JSON.stringify({ surveyId: surveyId, code: code, languageId: languageId })
          );
          redirectToSurvey();
        }
      })
    };
  

  const goToQuesPage = () => {
    if (!privacyChecked) {
      toast.error(t("acceptPrivacyNoticeError"), { position: "top-center", theme: "dark" });
      return;
    }
    navigate("/user/survey/opening-page/ques-page", {
      state: {
        surveyId, surveyTitle, endDate, backgroundImage, reloadKey: Date.now(), languageMasterId // Pass a unique key to trigger reload
      }
    });
  };

  const fetchSasToken = () => {
    setLoading(true);
    getSasToken().then((response) => {
      if (response !== null) {
        setLoading(false);
        const token = response?.data;
        setImageToken(token);
      } else {
        setLoading(false);
      }
    });
  };

  return (
    <>
      {loading ? <Loader /> :
        <div className="opening-page col-sm-12" style={{ backgroundColor: `${backgroundImage?.color}` }}>
          <div className="col-sm-8" style={{display:'flex', justifyContent:'center'}}>
           { surveyImageUrl && <img src={surveyImageUrl + '?' + imageToken} alt={surveyImageUrl} style={{ width: '95%', height: 'auto', maxWidth:'60%' }} />}
           {/* <img src={surveyIcon} alt={'test'} style={{ width: '95%', height: 'auto' }} /> */}
          </div>
          <div className="user-rightSection col-sm-4">
            <h1 className="user-title1">{surveyTitle}</h1>
            <p className="user-date">{sessionStorage.getItem("surveyPreview") !== "true" ? moment(startDate).format('DD/MMM/YYYY') : moment(createdDate).format("DD/MMM/YYYY") }</p>
            <p className="user-invitation-text">{t("youAreInvited!")}</p>

            <div className="user-checkbox-group">
              <input
                type="checkbox"
                id="confirmation"
                checked={privacyChecked}
                onChange={e => setPrivacyChecked(e.target.checked)}
              />
              <label htmlFor="confirmation">{t("privacyNotice")}</label>
            </div>
            {privacyChecked && typeof location.state?.privacyNote === 'string' && location.state.privacyNote && (
              <pre className="noteText">
                {renderWithLinks(location.state.privacyNote?.replace(/<[^>]*>/g, ''))}
              </pre>
            )}
            <button className={privacyChecked ? "startButton" : "user-start-button"} onClick={goToQuesPage} disabled={isStartNowBtnDisabled} style={isStartNowBtnDisabled ? { opacity: 0.5, cursor: 'default' } : {}}>
              {t("startNow")}
            </button>
          </div>
        </div>
      }

      <ModalComponent
          modalTitle={<>Notice</>}
          modalText={
              <>
                  <div style={{fontWeight: '500'}}>
                      <span>
                          Kindly click on the globe icon 
                          <img
                              src={worldIcon}
                              alt="Languages"
                              className="globe"
                              style={{ margin: "2px 2px -3px" }}
                          />     
                          to view application in Japanese or Simplified Chinese if needed.
                      </span>
                  </div>
                  <div style={{marginTop: '2rem', fontWeight: '500'}}>
                      <span>
                          必要に応じて、地球儀アイコン 
                          <img
                              src={worldIcon}
                              alt="Languages"
                              className="globe"
                              style={{ margin: "2px 0px -2px" }}
                          /> 
                          をクリックして、アプリケーションを日本語または中国語（簡体字）で表示してください。
                      </span>
                  </div>
                  <div style={{marginTop: '2.5rem', fontWeight: '500'}}>
                      <span>
                          如需查看日语或简体中文版本的应用程序，请点击地球图标。
			                    <img
                            src={worldIcon}
                            alt="Languages"
                            className="globe"
                            style={{ margin: "0px 0px -2px" }}
                          /> 
                      </span>
                  </div>
              </>
          }
          fieldsData={<></>}
          isOpen={isWarningModalOpen}
          onClose={() => {
              setIsWarningModalOpen(false);
              sessionStorage.setItem('externalUserSurveyWarningShown', 'true');
          }}
      /> 
    </>
  );
};

export default OpeningPage;